var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("table", { staticClass: "tbl_row" }, [
      _vm._m(0),
      _c("tbody", [
        _c("tr", [
          _c("th", { attrs: { rowspan: "2" } }, [_vm._v("실화주1")]),
          _c(
            "td",
            [
              _c("e-auto-complete-cst-enm", {
                attrs: { "ctr-cd": _vm.ctrCd, "cd-nm": _vm.actCstEnm },
                on: { change: _vm.change1 },
              }),
            ],
            1
          ),
          _c("th", { attrs: { rowspan: "2" } }, [_vm._v("실화주2")]),
          _c(
            "td",
            [
              _c("e-auto-complete-cst-enm", {
                attrs: { "ctr-cd": _vm.ctrCd, "cd-nm": _vm.test2.actCstEnm },
                on: { change: _vm.change2 },
              }),
            ],
            1
          ),
          _c("th", { attrs: { rowspan: "2" } }, [_vm._v("readonly")]),
          _c(
            "td",
            [
              _c("e-auto-complete-cst-enm", {
                attrs: {
                  "ctr-cd": _vm.ctrCd,
                  "cd-nm": _vm.test2.actCstEnm,
                  "read-only": true,
                },
                on: { change: _vm.change2 },
              }),
            ],
            1
          ),
        ]),
        _c("tr", [
          _c("td", [
            _vm._v(
              " " + _vm._s(_vm.actCstEnm) + " (" + _vm._s(_vm.actCstCd) + ") "
            ),
          ]),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(_vm.test2.actCstEnm) +
                " (" +
                _vm._s(_vm.test2.actCstCd) +
                ") "
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { attrs: { width: "140" } }),
      _c("col"),
      _c("col", { attrs: { width: "140" } }),
      _c("col"),
      _c("col", { attrs: { width: "140" } }),
      _c("col"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }